import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
  ItemDetailsStickyButtonsSectionResp,
} from '@marketplace-web/domain/item-page-data'

import { ItemPageBuyButtonModel } from './types'

export const getItemPageBuyButtonPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageBuyButtonModel => ({
  itemId: itemDto.id.toString(),
  sellerId: itemDto.user.id.toString(),
  canBuy: itemDto.can_buy,
  canInstantBuy: itemDto.instant_buy,
  isReserved: itemDto.is_reserved,
  isHidden: itemDto.is_hidden,
  reservedForUserId: itemDto.reservation?.to_whom_id,
  closetCountdownEndDate: itemDto.user.closet_countdown_end_date || '',
})

export const getServerItemPageBuyButtonPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp | ItemDetailsStickyButtonsSectionResp,
): ItemPageBuyButtonModel => ({
  itemId: sidebarDto.id.toString(),
  sellerId: sidebarDto.seller_id.toString(),
  canBuy: sidebarDto.can_buy,
  canInstantBuy: sidebarDto.instant_buy,
  isReserved: sidebarDto.is_reserved,
  isHidden: sidebarDto.is_hidden,
  reservedForUserId: sidebarDto.reservation?.to_whom_id,
  closetCountdownEndDate: sidebarDto.closet_countdown_end_date || '',
})
